import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    DELETE_PROJECT: createActionType(FULL_NAMESPACE, "DELETE_PROJECT"),
    DELETE_PROJECT_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_PROJECT_COMPLETED")
};
